import { AppearanceToggle } from '@/components/appearance-toggle'
import { YeshumanWordmark } from '@/components/landing/yeshuman/yeshuman-brand-mark'
import {
  yeshumanBandAlt,
  yeshumanContentColumn,
} from '@/components/landing/yeshuman/yeshuman-layout'
import { yeshumanAnn, yeshumanAnnDim } from '@/components/landing/yeshuman/yeshuman-typography'
import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { LandingCtaLink } from '@/landing/landing-cta-link'
import { cn } from '@/lib/utils'
import { useGuestSurfaceTheme } from '@/hooks/use-guest-surface-theme'

export function YeshumanMarketingFooter() {
  const { guestTheme, guestPreference, setGuestTheme, themeToggleEnabled } = useGuestSurfaceTheme()

  return (
    <footer className={cn('pb-16 pt-[120px]', yeshumanBandAlt)}>
      <div className={yeshumanContentColumn}>
        <p>
          <YeshumanWordmark />
        </p>
        <div className={cn('mt-16 flex flex-col gap-6', yeshumanAnn, yeshumanAnnDim)}>
          <Separator variant="marketing" />
          <div className="flex flex-wrap items-center justify-between gap-4">
            <span className="flex items-center gap-3">
              <span>© 2026 Yes Human</span>
              {themeToggleEnabled ? (
                <span className="md:hidden">
                  <AppearanceToggle
                    variant="marketing"
                    size="compact"
                    marketingTheme={guestTheme}
                    marketingPreference={guestPreference}
                    onMarketingThemeChange={setGuestTheme}
                  />
                </span>
              ) : null}
            </span>
            <span className="flex flex-wrap items-center gap-x-2">
              <Button asChild variant="marketingLinkMuted" size="marketingLinkSm" pressFeedback>
                <LandingCtaLink to="/#build">Product</LandingCtaLink>
              </Button>
              <span aria-hidden>·</span>
              <Button asChild variant="marketingLinkMuted" size="marketingLinkSm" pressFeedback>
                <LandingCtaLink to="/#lands">How it lands</LandingCtaLink>
              </Button>
              <span aria-hidden>·</span>
              <Button asChild variant="marketingLinkMuted" size="marketingLinkSm" pressFeedback>
                <LandingCtaLink to="/concepts">Concepts</LandingCtaLink>
              </Button>
              <span aria-hidden>·</span>
              <Button asChild variant="marketingLinkMuted" size="marketingLinkSm" pressFeedback>
                <LandingCtaLink to="/concepts/topology">Topology</LandingCtaLink>
              </Button>
              <span aria-hidden>·</span>
              <Button asChild variant="marketingLinkMuted" size="marketingLinkSm" pressFeedback>
                <LandingCtaLink to="/#talk">Talk to us</LandingCtaLink>
              </Button>
            </span>
          </div>
        </div>
      </div>
    </footer>
  )
}
